// extracted by mini-css-extract-plugin
export default {"spacer":"styles_spacer__OPljh","product":"styles_product__NBrU5","icon":"styles_icon__SnGya"};